export function shouldHideNoFitRunout(data: Gravitate.Order | undefined): boolean {
  if (!data) return true
  return data.type?.toLowerCase() === 'backhaul' || data.state === 'complete'
}
